interface PhoneMockupScreenProps {
	communityName: string;
	appName?: string | null;
	iconUrl?: string | null;
	splashColor?: string | null;
	primaryColor?: string | null;
}

const FALLBACK_SPLASH = "oklch(0.55 0.22 254)";

const FEED_ROWS = [
	{ titleWidth: "85%", subtitleWidth: "60%" },
	{ titleWidth: "70%", subtitleWidth: "45%" },
	{ titleWidth: "92%", subtitleWidth: "55%" },
] as const;

export function PhoneMockupScreen({ communityName, appName, iconUrl, splashColor, primaryColor }: PhoneMockupScreenProps) {
	const headerBg = splashColor ?? primaryColor ?? FALLBACK_SPLASH;
	const accent = primaryColor ?? splashColor ?? FALLBACK_SPLASH;
	const displayName = appName ?? communityName;

	return (
		<div className="flex h-full w-full flex-col">
			<div className="relative flex flex-col items-center justify-center px-6 pt-16 pb-8" style={{ background: headerBg }}>
				<div
					className="absolute inset-0 opacity-30"
					style={{ background: "radial-gradient(circle at 30% 20%, white 0px, transparent 60%)" }}
				/>
				{iconUrl ? (
					<img src={iconUrl} alt={displayName} className="relative h-20 w-20 rounded-2xl object-cover shadow-xl ring-1 ring-white/30" />
				) : (
					<div
						className="relative flex h-20 w-20 items-center justify-center rounded-2xl bg-white/20 shadow-xl ring-1 ring-white/30 backdrop-blur"
						aria-hidden
					>
						<span className="text-3xl font-bold text-white">{communityName.charAt(0).toUpperCase()}</span>
					</div>
				)}
				<p className="relative mt-4 truncate text-center text-base font-semibold text-white">{displayName}</p>
			</div>

			<div className="flex flex-1 flex-col gap-3 bg-white px-4 py-5">
				<div className="flex items-center justify-between">
					<span className="text-[11px] font-semibold uppercase tracking-wider text-neutral-500">Community feed</span>
					<span className="h-2 w-2 rounded-full" style={{ background: accent }} />
				</div>
				{FEED_ROWS.map((row, idx) => (
					<div key={`mock-row-${idx}`} className="flex gap-3 rounded-xl border border-neutral-100 bg-neutral-50/50 p-3">
						<div className="h-9 w-9 shrink-0 rounded-full" style={{ background: `${accent}20` }} />
						<div className="flex flex-1 flex-col gap-2">
							<div className="h-2.5 rounded-full bg-neutral-200" style={{ width: row.titleWidth }} />
							<div className="h-2 rounded-full bg-neutral-200/70" style={{ width: row.subtitleWidth }} />
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
